import React from "react";
import useGlobalHook from "use-global-hook";

import {generalActions, generalState} from "./actions/genaralActions";
import {supervisorState, supervisorActions} from "./actions/supervisorActions";
import {ticketActions, ticketState} from "./actions/ticketActions";
import {userActions, userState} from "./actions/userActions";

const initialState = {
    ...userState,
    ...ticketState,
    ...generalState,
    ...supervisorState
};


const actions = {
    ...userActions,
    ...ticketActions,
    ...generalActions,
    ...supervisorActions
};

const useGlobal = useGlobalHook(React, initialState, actions);

export default useGlobal;
